import React from 'react';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { Edit2, AlertCircle } from 'react-feather';
import { style, useUserProfileCompleted } from '../../../../api';
import Button from '../../../../VuexyDesign/atoms/Button';

export default styled(({ className }: { className?: string }) => {
  const { complete } = useUserProfileCompleted();
  const { t } = useTranslation('profile');
  return (
    <Button color="dark" className={className} outline>
      <>
        {complete ? (
          <Edit2 size={14} color={style.dark} className="mr-50" />
        ) : (
          <AlertCircle size={14} color={style.error_new} className="mr-50" />
        )}
        {complete
          ? t('profile:editProfile')
          : t('profile:completeYourProfileButton')}
      </>
    </Button>
  );
})``;
